import { z } from 'zod'
import { GameTypeEnum } from '../types'

export const createGameTemplateSchema = z.object({
  templateName: z
    .string()
    .min(1, 'Tên template là bắt buộc')
    .max(100, 'Tên template không được quá 100 ký tự'),
  gameType: z.nativeEnum(GameTypeEnum, {
    message: 'Loại game là bắt buộc',
  }),
  defaultGameConfig: z
    .string()
    .optional()
    .refine((value) => {
      if (!value) return true
      try {
        JSON.parse(value)
        return true
      } catch {
        return false
      }
    }, 'Game config phải là JSON hợp lệ'),
  defaultUiConfig: z
    .string()
    .optional()
    .refine((value) => {
      if (!value) return true
      try {
        JSON.parse(value)
        return true
      } catch {
        return false
      }
    }, 'UI config phải là JSON hợp lệ'),
  howToPlay: z.string().min(1, 'Hướng dẫn chơi là bắt buộc'),
  rules: z.string().min(1, 'Quy định là bắt buộc'),
  thumbnailUrl: z
    .string()
    .url('URL hình ảnh không hợp lệ')
    .optional()
    .or(z.literal('')),
})

export type CreateGameTemplateFormData = z.infer<
  typeof createGameTemplateSchema
>
